import { defineComponent as _defineComponent } from 'vue'
import VsAutocomplete from '@/components/vision/Inputs/VsAutocomplete/VsAutocomplete.vue'
import { computed } from 'vue'
import { EligibleServiceProvider } from '../../api/pools'
import { AdHocPoolStage } from './AdHocPoolCreator.vue'
import { addOrdinalIndicator } from '@/utils/number-formatting'


export default /*#__PURE__*/_defineComponent({
  __name: 'AdHocPoolStageCreator',
  props: {
    stage: null,
    selectableServiceProviders: null
  },
  emits: ["update-stage", "remove-stage"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'update-stage', adHocPoolStage: AdHocPoolStage)
  (e: 'remove-stage', stageNumber: number)
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  stage: AdHocPoolStage
  selectableServiceProviders: EligibleServiceProvider[]
}





const updateServiceProviders = (value) => {
  emits('update-stage', {
    stageNumber: props.stage.stageNumber,
    recipients: value,
  })
}
const handleSelectAllButton = () => {
  let recipients: string[] = []

  if (props.stage.recipients.length < props.selectableServiceProviders.length) {
    recipients = props.selectableServiceProviders.map((r) => r.id)
  }

  emits('update-stage', {
    stageNumber: props.stage.stageNumber,
    recipients,
  })
}

const removeStage = () => {
  emits('remove-stage', props.stage.stageNumber)
}

const selectAllIcon = computed(() => {
  return props.stage.recipients.length < props.selectableServiceProviders.length
    ? 'mdi-plus-box'
    : 'mdi-minus-box'
})
const selectAllLabel = computed(() => {
  return props.stage.recipients.length < props.selectableServiceProviders.length
    ? 'Select All'
    : 'Deselect All'
})

const label = computed<string>(() => {
  const ordinalNumber = addOrdinalIndicator(props.stage.stageNumber)
  return `Notify ${ordinalNumber}`
})

return { __sfc: true,emits, props, updateServiceProviders, handleSelectAllButton, removeStage, selectAllIcon, selectAllLabel, label, VsAutocomplete }
}

})